import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserService } from '../service/user.service';
import { UserAction } from '../store/user.action';

@Injectable()
export class UserGuard implements CanActivate {

    constructor(private userService: UserService,
                private router: Router,
                private store: Store) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.store.dispatch(new UserAction.ClearCurrentUser());
        return this.userService.getCurrentUser()
            .pipe(
                switchMap(user => {
                    return this.store.dispatch(new UserAction.SetCurrentUser(user))
                        .pipe(map(() => true));
                }),
                catchError(
                    () => this.store.dispatch(new UserAction.LoginFailed())
                        .pipe(() => {
                            this.router.navigate(['/login'], {queryParams: {link: state.url}});
                            return of(false);
                        }))
            );
    }
}
